import { render, staticRenderFns } from "./BeneficiaryCustomField.vue?vue&type=template&id=11803b89&"
import script from "./BeneficiaryCustomField.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports